// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"797":"3dfc73c0","827":"10440573"}[chunkId] + ".chunk.js";
};